export enum CodeSearchTypesEnum {
  IDS = 'ids',
  TEXT = 'text',
  NODE = 'nodeRef'
}

export const SEARCH_TYPES: {type: CodeSearchTypesEnum; value: string}[] = [
  {type: CodeSearchTypesEnum.TEXT, value: 'CODE_SEARCH.TEXT_SEARCH'},
  {type: CodeSearchTypesEnum.IDS, value: 'CODE_SEARCH.IDS_SEARCH'}
];

export const AVAILABLE_METADATA_TYPES = [
  'ApexClass',
  'ApexTrigger',
  'AuraDefinitionBundle',
  'DataMapper',
  'Flow',
  // 'Field',
  'FlexCard',
  'LightningComponentBundle',
  'OmniScript',
  'OmniIntegrationProcedure'
  // 'Records'
];
